import { Badge } from "@/components/ui/badge"

export default function AgendaCreateEventStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Crear un evento</h1>
      </header>
      <p className="text-left text-sm text-muted-foreground">
        Creá eventos únicos o recurrentes para organizar tu agenda, mantenerla al día y administrar
        mejor tu tiempo de estudio.
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 1 de 8</span>
      </Badge>
    </section>
  )
}
